/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CosmosRichText, CosmosTextVariants } from "@components/elements";
import { closeRichTextHeadingGaps } from "@components/elements/atoms/text/text.utils";

import { css, cx } from "@panda/css";

interface Props {
	html?: string;
	className?: string;
	textStyle?: CosmosTextVariants;
}

export const LicenseCardDescription = ({
	html,
	className,
	textStyle = "paragraphMD",
}: Props): React.JSX.Element | null => {
	if (!html) return null;

	return (
		<CosmosRichText
			className={cx(
				className,
				css({
					color: "eds.text.secondary",
					textStyle,
					"& strong": {
						color: "eds.text.primary",
						marginBottom: "eds.dimension.12",
					},
					"& p": {
						minHeight: "16px",
					},
					"& h4": {
						marginBottom: "0",
					},
					"& h5": {
						marginBottom: "0",
					},
					"&& li": {
						marginInlineStart: "8px",
						marginBlockEnd: "2px",
					},
					"&& ul": {
						marginBlock: "0",
						paddingInlineStart: "18px",
						listStyle: "disc",
					},
				}),
			)}
			// Card titles render h3, so close gaps in authored description headings to nest
			// at h4 (aria-level only) — e.g. an authored <h5> otherwise skips h4.
			html={closeRichTextHeadingGaps(html, 4)}
		/>
	);
};
